import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { LayersContext } from '../baseui/layer';
import { useMemo } from 'react';
import { useDocument } from '../spacewebProvider/DocumentProvider';
import { LAYERS_DEFAULT_ZINDEX } from './constants';
import useLayersContextValue from './useLayersContextValue';
LayersContext.displayName = 'BaseUILayerContext';
var LayersManager = function (_a) {
    var children = _a.children, zIndexToOverride = _a.zIndex, hostToOverride = _a.host;
    var ctxValue = useLayersContextValue();
    var doc = useDocument();
    var defaultHostContainer = doc === null || doc === void 0 ? void 0 : doc.body;
    var value = useMemo(function () {
        var _a, _b;
        return (__assign(__assign({}, ctxValue), { host: (_a = hostToOverride !== null && hostToOverride !== void 0 ? hostToOverride : ctxValue.host) !== null && _a !== void 0 ? _a : defaultHostContainer, zIndex: (_b = zIndexToOverride !== null && zIndexToOverride !== void 0 ? zIndexToOverride : ctxValue.zIndex) !== null && _b !== void 0 ? _b : LAYERS_DEFAULT_ZINDEX }));
    }, [ctxValue, hostToOverride, zIndexToOverride, defaultHostContainer]);
    // TODO :- To remove this ts error
    // @ts-ignore
    return _jsx(LayersContext.Provider, __assign({ value: value }, { children: children }), void 0);
};
export default LayersManager;
